import React from 'react'
import styled from 'styled-components'
import { colors } from 'utils'
import Icon, { IconProps } from './Icon'

const S = {
    IconInfo: styled(Icon)`
        &:hover svg > path {
            fill: ${colors.icon} !important;
        }
    `
}

const InfoIcon = ({ isDisable, ...props }: Omit<IconProps, 'icon'> & { isDisable?: boolean }) => (
    <S.IconInfo
        {...props}
        icon="info"
        color={isDisable ? '#BBC7CD' : '#9AACB5'}
    />
)

export default InfoIcon
